import React, { useEffect, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";
import PieChart from "./pieChart";
import * as HTTPServices from "../../../api/HTTPServices";
import CircularProgress from "@mui/material/CircularProgress";
import DataTable from "../../../components/DataTable";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
    width: "100%",
  },
}));

export default function ChartOverview() {
  const { t } = useTranslation();
  const [overviewData, setOverviewData] = useState();
  const [pieData, setPieData] = useState();
  const [lineChartData, setLineChartData] = useState();
  const [doctorData, setDoctorData] = useState();
  const [columnDataTable, setColumnDataTable] = useState([]);
  const [rowDataTable, setRowDataTable] = useState([]);

  const classes = useStyles();

  useEffect(() => {
    let RequestService = HTTPServices.getMethod(
      "doctor_transaction_overView",
      "",
      "true"
    );

    const RequestLineChartData = HTTPServices.getMethod(
      "doctor_transaction_chart",
      "",
      "true"
    );

    const RequestProfileService = HTTPServices.getMethod(
      "doctor_profile",
      "",
      "true"
    );

    RequestService.then(function (response) {
      if (response) {
        let pieData;
        pieData = createData(
          response[0].success,
          response[0].cancel,
          response[0].not_end
        );
        setPieData(pieData);
        setOverviewData(response);
      }
    });

    RequestLineChartData.then(function (res) {
      if (res) {
        let lineChartData = [];
        let dynamicDataTableCulumn = [];
        let dataTableRows = [];
        var dynamcKey = {};

        var len = res.length;
        for (var i = 0; i < len; i++) {
          lineChartData.push({
            name: parseInt(res[i].month),
            allOfThem: parseInt(res[i].allOfThem),
            cancel: parseInt(res[i].cancel),
            success: parseInt(res[i].success),
          });

          dynamicDataTableCulumn.push({
            field: parseInt(res[i].month),
            // headerName: parseInt(res[i].month),
            headerName:
              parseInt(res[i].month) === 1
                ? "month 1"
                : parseInt(res[i].month) === 2
                ? "month 2"
                : parseInt(res[i].month) === 3
                ? "month 3"
                : parseInt(res[i].month) === 4
                ? "month 4"
                : parseInt(res[i].month) === 5
                ? "month 5"
                : parseInt(res[i].month) === 6
                ? "month 6"
                : parseInt(res[i].month) === 7
                ? "month 7"
                : parseInt(res[i].month) === 8
                ? "month 8"
                : parseInt(res[i].month) === 9
                ? "month 9"
                : parseInt(res[i].month) === 10
                ? "month 10"
                : parseInt(res[i].month) === 11
                ? "month 11"
                : parseInt(res[i].month) === 12
                ? "month 12"
                : "nothing",

            width: 120,

            // renderCell: (params) => {
            //   return "1";
            // },
          });

          dynamcKey[parseInt(res[i].month)] = parseInt(res[i].success);
          dynamcKey["id"] = parseInt(res[i].month);
        }
        dataTableRows.push(dynamcKey);

        setLineChartData(lineChartData);
        setColumnDataTable(dynamicDataTableCulumn);
        setRowDataTable(dataTableRows);
      }
    });

    RequestProfileService.then(function (result) {
      if (result) {
        setDoctorData(result);
      }
    });
  }, []);

  function createData(success, cancel, not_end) {
    return [
      { name: "success", value: parseInt(success) },
      { name: "cancel", value: parseInt(cancel) },
      { name: "not_end", value: parseInt(not_end) },
    ];
  }

  return (
    <div className={classes.root}>
      {!overviewData ? (
        <div style={{ textAlign: "center", paddingTop: 20 }}>
          <CircularProgress />
          <p
            style={{
              fontSize: 16,
            }}
          >
            {t("pages.protectedPages.transactions.overview.loading")}
          </p>
        </div>
      ) : (
        <>
          <Grid container spacing={3}>
            <Grid item lg={4} md={4} xs={12} sm={12}>
              <div
                className={classes.paper}
                style={{ backgroundColor: "#f4ebfb" }}
              >
                <h4>
                  {t("pages.protectedPages.transactions.overview.summary")}
                </h4>
                <div
                  style={{
                    lineHeight: "30px",
                    fontSize: "14px",
                    textAlign: "left",
                  }}
                >
                  <p>
                    {t(
                      "pages.protectedPages.transactions.overview.successfulVisits"
                    )}
                    {overviewData && overviewData[0].success}
                  </p>
                  <p>
                    {t("pages.protectedPages.transactions.overview.deposit")}
                    {overviewData && overviewData[0].amount}
                  </p>
                  <p>
                    {t("pages.protectedPages.transactions.overview.balance")}
                    {overviewData && overviewData[0].amount_pending}
                  </p>
                </div>
              </div>
              <div
                className={classes.paper}
                style={{
                  backgroundColor: "#f4ebfb",
                  marginTop: 10,
                }}
              >
                <h5>{t("pages.protectedPages.transactions.overview.sheba")}</h5>
                <p
                  style={{
                    fontSize: "14px",
                    textAlign: "left",
                  }}
                >
                  {"IR" + doctorData?.profile.account_sheba}
                </p>
              </div>
            </Grid>

            <Grid item lg={8} md={8} style={{ overflow: "auto" }}>
              <div className={classes.paper} style={{ textAlign: "center" }}>
                <h3 style={{ padding: 10 }}>
                  {t(
                    "pages.protectedPages.transactions.overview.visitsGraphPerMonth"
                  )}
                </h3>
                <div
                  style={{
                    textAlign: "center",
                    overflow: "auto",
                  }}
                >
                  <LineChart
                    width={700}
                    height={300}
                    data={lineChartData}
                    margin={{
                      top: 5,
                      right: 30,
                      left: 20,
                      bottom: 5,
                    }}
                  >
                    <CartesianGrid strokeDasharray="3 3" />
                    <XAxis dataKey="name" />
                    <YAxis />
                    <Tooltip />
                    <Legend />
                    <Line
                      type="monotone"
                      dataKey="success"
                      stroke="green"
                      // activeDot={{ r: 8 }}
                    />
                    <Line type="monotone" dataKey="cancel" stroke="red" />
                    <Line type="monotone" dataKey="allOfThem" stroke="blue" />
                  </LineChart>
                </div>
              </div>
            </Grid>

            <Grid item lg={12} md={12} style={{ overflow: "auto" }}>
              <Paper className={classes.paper}>
                <h3 style={{ padding: 10 }}>
                  {t(
                    "pages.protectedPages.transactions.overview.visitPerMonthTable"
                  )}
                </h3>
                <div
                  style={{
                    textAlign: "center",
                    // overflow: "auto",
                    minWidth: 700,
                  }}
                >
                  <DataTable rows={rowDataTable} columns={columnDataTable} />
                </div>
              </Paper>
            </Grid>

            <Grid item lg={4} md={4} xs={12} sm={12}>
              <Paper
                className={classes.paper}
                style={{ backgroundColor: "#f4ebfb" }}
              >
                <h4>
                  {t(
                    "pages.protectedPages.transactions.overview.visitreportSummary"
                  )}
                </h4>
                <div
                  style={{
                    lineHeight: "30px",
                    fontSize: "14px",
                  }}
                >
                  <p>
                    {t(
                      "pages.protectedPages.transactions.overview.totalReqisteredVisit"
                    )}
                    {overviewData && overviewData[0].allOfThem}
                  </p>
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <div
                      style={{
                        borderRadius: "50%",
                        border: 1,
                        width: 20,
                        height: 20,
                        backgroundColor: "#7747c0",
                      }}
                    ></div>
                    <p
                      style={{
                        color: "#7747c0",
                        paddingRight: 10,
                      }}
                    >
                      {t(
                        "pages.protectedPages.transactions.overview.totalSuccessfulVisits"
                      )}
                      {overviewData && overviewData[0].success}
                    </p>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      verticalAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "50%",
                        border: 1,
                        width: 20,
                        height: 20,
                        backgroundColor: "#ea4335",
                        alignItems: "center",
                      }}
                    ></div>
                    <p
                      style={{
                        color: "#ea4335",
                        paddingRight: 10,
                      }}
                    >
                      {t(
                        "pages.protectedPages.transactions.overview.totalCanselVisits"
                      )}
                      {overviewData &&
                        parseInt(overviewData[0].cancel) +
                          parseInt(overviewData[0].refunded)}
                    </p>
                  </div>

                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      verticalAlign: "center",
                    }}
                  >
                    <div
                      style={{
                        borderRadius: "50%",
                        border: 1,
                        width: 20,
                        height: 20,
                        backgroundColor: "#0ba222",
                        alignItems: "center",
                      }}
                    ></div>
                    <p
                      style={{
                        color: "#0ba222",
                        paddingRight: 10,
                      }}
                    >
                      {t(
                        "pages.protectedPages.transactions.overview.totalOpenVisits"
                      )}
                      {overviewData && overviewData[0].not_end}
                    </p>
                  </div>
                </div>
              </Paper>
            </Grid>

            <Grid item lg={8} style={{ overflow: "auto" }}>
              <Paper className={classes.paper}>
                <Grid
                  xs={12}
                  style={{
                    textAlign: "center",
                  }}
                >
                  <h3 style={{ padding: 10 }}>
                    {t("pages.protectedPages.transactions.overview.totalGraph")}
                  </h3>
                </Grid>
                <div
                  style={{
                    overflow: "auto",
                  }}
                >
                  <PieChart data={pieData} />
                </div>
              </Paper>
            </Grid>
          </Grid>
        </>
      )}
    </div>
  );
}
